import Booking from '../components/Booking.js';

export default function Reservations() {
    return (
        <>
            <Booking />
        </>
    );
}